module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Since she was a little girl selling fried banana in her hometown, Nan always lived her life her own way. When traveling was still a foreign concept in Indonesia, she already went backpacking alone or cruising on her dirt bike. She has traveled to many corners of the world and is counting. Experiencing different social and environmental landscapes has made her attached to conservation and animal-welfare issue. After finishing her postgraduate scholarships, she started working for several NGOs and co-founded Reef Check Foundation Indonesia. She now lives in Canada with her two dogs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0